var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyVolumeWorldMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 99,
    viewBox: "0 0 86 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5977 97.1993H77.899C79.6663 97.1993 81.0991 95.7666 81.0991 93.9992V55.5995C81.0991 53.8321 79.6663 52.3994 77.899 52.3994H74.6989",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.701 52.4004H7.50088C5.73351 52.4004 4.30078 53.8331 4.30078 55.6005V94.0002C4.30078 95.7676 5.73351 97.2003 7.50088 97.2003H23.8041",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7007 90.7996C42.7007 87.2649 39.8352 84.3994 36.3005 84.3994H10.7012V87.5995C10.7012 89.3669 12.1339 90.7996 13.9013 90.7996H42.7007Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7012 84.3992V49.2011C10.7012 47.4337 12.1339 46.001 13.9013 46.001H36.3005C39.8352 46.001 42.7007 48.8664 42.7007 52.4012V90.8009",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7012 90.7996C42.7012 87.2649 45.5666 84.3994 49.1014 84.3994H74.7007V87.5995C74.7007 89.3669 73.268 90.7996 71.5006 90.7996H42.7012Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7007 84.3992V49.2011C74.7007 47.4337 73.268 46.001 71.5006 46.001H49.1014C45.5666 46.001 42.7012 48.8664 42.7012 52.4012V90.8009",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.955 58.8001H23.4461C22.5929 58.8001 21.9004 58.1076 21.9004 57.2544V53.9442C21.9004 53.0909 22.5929 52.3984 23.4461 52.3984H29.955C30.8082 52.3984 31.5007 53.0909 31.5007 53.9442V57.2544C31.5007 58.1076 30.8082 58.8001 29.955 58.8001Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3007 65.2002H17.1016",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3007 71.5996H17.1016",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3007 77.999H17.1016",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.955 58.8001H55.4461C54.5929 58.8001 53.9004 58.1076 53.9004 57.2544V53.9442C53.9004 53.0909 54.5929 52.3984 55.4461 52.3984H61.955C62.8082 52.3984 63.5007 53.0909 63.5007 53.9442V57.2544C63.5007 58.1076 62.8082 58.8001 61.955 58.8001Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2987 65.2002H49.0996",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2987 71.5996H49.0996",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2987 77.999H49.0996",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9023 46.0006C13.9023 30.0957 26.7969 17.2012 42.7018 17.2012C58.6066 17.2012 71.5012 30.0957 71.5012 46.0006",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3008 46.0006C28.3008 30.0957 34.7473 17.2012 42.7005 17.2012C50.6537 17.2012 57.1002 30.0957 57.1002 46.0006",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.167 26.7998C58.8938 29.7464 51.2304 31.5992 42.7007 31.5992C34.1709 31.5992 26.5075 29.7449 21.2344 26.7998",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4121 26.4189C82.5311 32.2542 84.2999 38.9209 84.2999 45.9991C84.2999 51.6793 83.1612 57.0929 81.0998 62.0256",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.832 13.6309C71.5092 15.7952 73.9125 18.284 75.9826 21.0393",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8965 4.52246C52.4792 5.02225 58.6331 7.05472 64.0033 10.2635",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41992 21.0382C16.4097 11.7334 27.2095 5.4549 39.5043 4.52051",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30166 62.0281C2.24021 57.0954 1.10156 51.6803 1.10156 46C1.10156 38.9219 2.87038 32.2551 5.9879 26.4199",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9002 4.40029C45.9002 6.16766 44.4675 7.60039 42.7001 7.60039C40.9327 7.60039 39.5 6.16766 39.5 4.40029C39.5 2.63292 40.9327 1.2002 42.7001 1.2002C44.4675 1.20164 45.9002 2.63437 45.9002 4.40029Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.701 23.6005C10.701 25.3679 9.26825 26.8006 7.50088 26.8006C5.73351 26.8006 4.30078 25.3679 4.30078 23.6005C4.30078 21.8331 5.73496 20.4004 7.50233 20.4004C9.26825 20.4004 10.701 21.8331 10.701 23.6005Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0994 23.6005C81.0994 25.3679 79.6667 26.8006 77.8993 26.8006C76.1319 26.8006 74.6992 25.3679 74.6992 23.6005C74.6992 21.8331 76.1319 20.4004 77.8993 20.4004C79.6667 20.4004 81.0994 21.8331 81.0994 23.6005Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyVolumeWorldMarket);
export default __webpack_public_path__ + "static/media/metodology-volume-world-market.56d2f08d1d921082e534c8568cd132e9.svg";
export { ForwardRef as ReactComponent };